import React from 'react';

import { email } from '../../attrs/content';
import { rootDomainUrl } from '../../utils/url';
import { ACADEMY_URL, INSIGHTS_URL } from '../../constants/app';

import SignupLoginButtons from '../signupLoginButtons';
import UserMenu from '../userMenu';
import AuthenticationGate from '../authenticationGate';

import { Container, Menu, MenuItem, MenuLink, MenuNavLink } from './style';

const Navigation = () => (
  <Container>
    <Menu>
      <MenuItem>
        <MenuNavLink exact subtle to="/">
          Home
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink subtle to="/metrics">
          Charts
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink subtle to="/dashboards">
          Dashboards
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink subtle to="/compare">
          Compare
        </MenuNavLink>
      </MenuItem>
      <MenuItem>
        <MenuNavLink subtle to="/reports">
          Reports
        </MenuNavLink>
      </MenuItem>
    </Menu>

    <Menu>
      <MenuItem>
        <MenuNavLink to="/pricing">Pricing</MenuNavLink>
      </MenuItem>

      <MenuItem>
        <MenuLink href={INSIGHTS_URL} rel="noopener noreferrer" target="_blank">
          Insights
        </MenuLink>
      </MenuItem>

      <MenuItem>
        <MenuLink href={ACADEMY_URL} rel="noopener noreferrer" target="_blank">
          Academy
        </MenuLink>
      </MenuItem>

      <MenuItem>
        <MenuLink href={rootDomainUrl('/metrics')} rel="noopener noreferrer" target="_blank">
          Catalog
        </MenuLink>
      </MenuItem>

      <MenuItem>
        <MenuLink href={rootDomainUrl('/company')} rel="noopener noreferrer" target="_blank">
          About
        </MenuLink>
      </MenuItem>

      <MenuItem>
        <MenuLink href={`mailto:${email}`}>Contact</MenuLink>
      </MenuItem>

      <MenuItem>
        <AuthenticationGate fallbackComponent={<SignupLoginButtons />}>
          <UserMenu />
        </AuthenticationGate>
      </MenuItem>
    </Menu>
  </Container>
);

export default Navigation;
